/**
 * Initials for an avatar: "Avery Tremblay" → "AT", "Élise Thériault" → "ÉT".
 *
 * The one implementation every portal uses, so a person is the same two
 * letters in the top bar, a chat thread, the team map and the admin lists.
 *
 * - Letters only, in any script (`\p{L}`), so accented and non-Latin names keep
 *   their first letter instead of being skipped.
 * - A parenthesised aside is not part of the name: "JAD (Clerk)" → "J", not
 *   "J(" or "JC".
 * - Punctuation is ignored, so "M. Rourke" → "MR".
 * - First and last word, so "Jean Paul Leblanc" → "JL"; a single word gives its
 *   first letter.
 * - Nothing usable yields an empty string; the caller chooses its own fallback.
 */
export function initialsOf(name: string | null | undefined): string {
  if (!name) return '';
  const words = name
    .normalize('NFC')
    // Drop "(Clerk)", "[contractor]" and the like — a role, not a name.
    .replace(/\([^)]*\)|\[[^\]]*\]/g, ' ')
    .split(/\s+/)
    .map((word) => word.match(/\p{L}/u)?.[0] ?? '')
    .filter(Boolean);
  if (words.length === 0) return '';
  const letters = words.length === 1 ? words[0] : words[0] + words[words.length - 1];
  return letters.toLocaleUpperCase();
}
